import { Injectable } from '@angular/core';
import { IamService } from '@app/core/services/iam.service';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, concatMap, map } from 'rxjs/operators';
import { Constant } from 'src/constant';
import { SsoActions } from '../actions';
import { ProviderType, ProviderStatus } from '@app/shared/models/provider';
import { DomainService } from '@app/core/services/domain.service';
import { Domain } from '@app/shared/models/domain';

@Injectable()
export class SsoEffects {

  getMainProvider$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SsoActions.getMainProvider),
      concatMap(() => {
        return this.iamService.getProviders().pipe(
          map((response: any) => {
            const provider = response.providers.find(({ name }) => name === Constant.SsoParams.name);
            return SsoActions.getMainProviderSuccess({ provider });
          }),
          catchError(error =>
            of(SsoActions.getMainProviderFailure({ error: error.message }))
          )
        );
      })
    )
  );

  createProvider$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SsoActions.createProvider),
      concatMap(({ provider }) => {
        const providerData = {
          ...provider,
          type: Constant.SsoParams.types.SAML as ProviderType,
          name: Constant.SsoParams.name,
          status: Constant.ssoProviderStatus.enabled as ProviderStatus,
        };
        return this.iamService.postProvider(providerData).pipe(
          map(({ provider: createdProvider }) => {
            return SsoActions.createProviderSuccess({ provider: createdProvider });
          }),
          catchError(error =>
            of(SsoActions.createProviderFailure({ error: error.message }))
          )
        );
      })
    )
  );

  updateProvider$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SsoActions.updateProvider),
      concatMap((action) => {
        return this.iamService.deleteProvider(encodeURIComponent(action.oldIssuer)).pipe(
          concatMap(() => {
            const providerData = {
              ...action.provider,
              type: Constant.SsoParams.types.SAML,
              name: Constant.SsoParams.name,
              status: Constant.ssoProviderStatus.enabled,
            } as any;
            return this.iamService.postProvider(providerData).pipe(
              concatMap(({ provider }) => {
                return of(SsoActions.updateProviderSuccess({ provider }));
              }),
              catchError(error =>
                of(SsoActions.updateProviderFailure({ error: error.message }))
              )
            );
          })
        );
      })
    )
  );

  constructor(
    private actions$: Actions,
    private iamService: IamService,
  ) { }

}
